
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertCategoryA as ObiAlertCategoryAElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-category-a.js';
 
 
 

 
 export const ObiAlertCategoryA = createComponent({
   react: React,
   tagName: 'obi-alert-category-a',
   elementClass: ObiAlertCategoryAElement,
   events: {
     
   }
  });
 
 